import './multiple/multiple-select';
import './multiple/multiple-select.css';

import './fancybox/css/fancybox.less';
import './fancybox/js/fancybox';

import './toolTip/tipTip.less';
import './toolTip/jquery.tipTip';

import './swiper/swiper.min';
import './swiper/swiper.min.css';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
